import { cronosClient } from "@/config/client"

type ProductTourStatus = "completed" | "skipped" | null

export interface User {
  id: string
  firstName: string
  lastName: string
  universityId: string
  externalId: string
  role: UserRole
  dailyStudyHours: number
  profilePicUrl: string
  emailAddress: string
  sex: UserSex
  timeZone: string
  wasOnboarded: boolean
  productTour: ProductTourStatus
}

export enum UserRole {
  STUDENT = "student",
  SUPERVISOR = "supervisor",
}

export enum UserSex {
  F = "F",
  M = "M",
  X = "X",
}

export interface Response {
  description: {
    user: User
  }
}

export interface Params {
  body: {
    code: string
  }
  token: string
}

export function code({ body, token }: Params) {
  return cronosClient
    .setDefaultHeader("Authorization", `Bearer ${token}`)
    .post<Response, Params["body"]>("/v1/auth/login/code", body)
}
